/* eslint-disable */

/* webpack注入的变量 */

// 项目基础路径
export const BASE_PATH = basePath;

/* eslint-enable */

// 赛程表全部分类
export const EVENT_ALL = '全部';
